import React from 'react';
import { Input, Modal, Form, Flex, Button, Row, Col, Alert, Radio, message, Select } from 'antd';
import { DeleteOutlined, BarcodeOutlined } from '@ant-design/icons';
import { getCurrentShopId } from '../../pages/shop/get-current-shop';
import { scanBarcode } from '../../utils/jsbridge';
import { CopyToClipboard } from "react-copy-to-clipboard";

export default ({open = false, order, ...props }) => { 
    const [form] = Form.useForm();
    const [deliveryType, setDeliveryType] = React.useState('express');
    const [companies, setCompanies] = React.useState([{label: '', value: ''}]);

    const { appointment, meta: goods } = order;
    const fullAddrass = `${(appointment || goods?.appointmentInfo)?.province || ""}${(appointment || goods?.appointmentInfo)?.city || ""}${(appointment || goods?.appointmentInfo)?.county || ""}${(appointment || goods?.appointmentInfo)?.community || ""}${(appointment || goods?.appointmentInfo)?.address || ""}`;
    const customerName = (appointment || goods?.appointmentInfo)?.customerName || "无名";
    const customerPhoneNo = (appointment || goods?.appointmentInfo)?.phoneNo || "无";

    React.useEffect(() => {
        if(open && order.orderStatus >= 8) getPackages(order.parentOrderId);
    }, [open]);

    React.useEffect(() => {
        getCompanies();
    }, []);

    let historyCompany = null;
    try {
        historyCompany = JSON.parse(localStorage.getItem('logisticsCompany'));
    } catch (e) {
        historyCompany = null;
    }
    
    const defaultPacks = [
        {
            id: null,
            company: historyCompany ? historyCompany.label : '',
            number: ''
        }
    ];

    const initialValues = {
        packs: defaultPacks
    };

    const getCompanies = async () => {
        const response = await fetch('/api/logistics/company');
        const result = await response.json();

        if(result?.success) {
            setCompanies(result.data.map(({id, name}) => ({label: name, value: id})));
        }
    }


    // form.setFieldsValue({
    //     packs: defaultPacks
    // });

    const onOk = async () => {
        const values = await form.validateFields();
        
        values.deliveryType = deliveryType;
        values.parentOrderId = order.parentOrderId;
        values.type = 1;
        values.receiver = {
            name: (appointment || goods?.appointmentInfo)?.customerName || "无名",
            phoneNo: (appointment || goods?.appointmentInfo)?.phoneNo,
            address: fullAddrass
        };

        values.packs = values.packs.map(pack => ({
            ...pack,
            companyId: (companies.find(c => c.label === pack.company))?.value,
            // number: pack.number
        }));

        values.status = 3;

        postDelivery(values).then((res) => {
            props?.onOk(values);
        });
    };

    const onCancel = () => {
        // form.resetFields();
        if(props.onCancel) props.onCancel();
    };

    const deliveryTypeChange = (e) => {
        setDeliveryType(e.target.value);
    }

    const getPackages = async (parentOrderId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/logistics/list?parentOrderId=${parentOrderId}&shopId=${shopId}`);
        const result = await res.json();

        if(result?.success) {
            const rows = result?.data?.rows || [];
            
            if(rows.length > 0){
                const [{deliveryType}] = rows;
                setDeliveryType(deliveryType);

                if(deliveryType === 'express') {
                    form.setFieldsValue({
                        packs: result?.data?.rows || defaultPacks
                    });
                }
            }
        }else{
            form.setFieldsValue({
                packs: defaultPacks
            });
        }
    }

    const postDelivery = async (data) => {
        const shopId = await getCurrentShopId();
        const response = await fetch(`/api/order/delivery?shopId=${shopId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        const res = await response.json();

        if(res?.success) {
            message.success('操作成功');
        } else {
            message.error('操作失败');
        }
    }

    const scan = async (index) => {
        const barcode = await scanBarcode();
        console.log(barcode);
        
        // 更新指定索引处的包裹的快递单号
        const currentPacks = form.getFieldValue('packs') || [];
        const updatedPacks = [...currentPacks];
        
        if (updatedPacks[index]) {
            updatedPacks[index].number = barcode.data;
        } else {
            // 如果该索引处不存在包裹，则创建一个
            updatedPacks[index] = {
                ...updatedPacks[index],
                number: barcode.data
            };
        }
        
        form.setFieldsValue({
            packs: updatedPacks
        });
    }

    const addPackage = (add) => {
        const packs = form.getFieldValue('packs') || [];
        const lastPack = packs[packs.length - 1];
        add({ ...lastPack, number: '', id: null });
    }

    const onCompanyChange = (v, item) => {
        const company = companies.find(c => c.value === v);
        localStorage.setItem('logisticsCompany', JSON.stringify(company)); // Store the selected company in local storage
    }

    return (
        <Modal
            title="填写快递/物流信息"
            open={open}
            onCancel={onCancel}
            onOk={onOk}
            maskClosable={false}
        >
            <div style={{ margin: '20px 0'}}>
                <Alert 
                    title='收件人信息' 
                    description={
                        <div>
                            <b>收件人信息：</b>
                            {`${customerName} ${customerPhoneNo} ${fullAddrass}`}
                            <CopyToClipboard text={`${customerName} ${customerPhoneNo} ${fullAddrass}`} onCopy={() => message.success("复制成功")}>
                                <a> 复制</a>
                            </CopyToClipboard>
                        </div>
                    } 
                    type="info" 
                    style={{margin: '0 0 10px 0'}} 
                />

                <Radio.Group defaultValue={'express'} value={deliveryType} style={{ margin: '0 0 10px 0'}} onChange={e => deliveryTypeChange(e)} options={[
                    {
                        label: '快递/物流',
                        value: 'express'
                    },
                    {
                        label: '自提',
                        value: 'self_pick'
                    },
                    {
                        label: '无需物流',
                        value: 'no_express'
                    },
                ]} />

                {deliveryType === 'express' && 
                    <Form form={form} initialValues={initialValues}>
                        <Form.List name="packs"> 
                            {
                                (fields, {add, remove}, {errors}) => (
                                    <>
                                        <Row gutter={[10, 10]}>
                                            <Col span={3}></Col>
                                            <Col span={7}><span style={{color: 'red'}}>* </span>快递公司</Col>
                                            <Col span={14}><span style={{color: 'red'}}>* </span>快递单号</Col>
                                        </Row>
                                        <> 
                                            {fields.map((field, index) => {
                                                return ( 
                                                    <Row key={index} gutter={[10, 10]}>
                                                        <Col span={3}>
                                                            <Form.Item>
                                                                {`包${index + 1}`}
                                                            </Form.Item>
                                                            <Form.Item name={[field.name, 'id']} hidden>
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={7}>
                                                            <Form.Item
                                                                name={[field.name, 'company']}
                                                                rules={[{required: true, message: '请填写快递公司'}]}
                                                            >
                                                                {/* <Input placeholder="请填写快递公司" /> */}
                                                                <Select placeholder="请选择快递公司" options={companies} onChange={onCompanyChange} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={11}>
                                                            <Form.Item
                                                                name={[field.name, 'number']}
                                                                rules={[{required: true, message: '请填写快递单号'}]}
                                                            >
                                                                <Input placeholder="请填写快递单号" />
                                                            </Form.Item>
                                                            
                                                        </Col>
                                                        <Col span={3} style={{fontSize: '18px'}}>
                                                            <Flex style={{margin: '6px 0 0 0'}}>
                                                                <BarcodeOutlined onClick={() => scan(index)} />
                                                                { fields.length > 1 && <DeleteOutlined style={{margin: '0 0 0 10px'}} onClick={() => remove(index)} />}
                                                            </Flex>
                                                        </Col>
                                                    </Row>
                                                )
                                            })}
                                        </>
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => addPackage(add)} block>
                                                添加包裹
                                            </Button>
                                        </Form.Item>
                                    </>
                                )
                            }
                        </Form.List>
                    </Form>
                }
            </div>
        </Modal>
    )
};